import React from 'react';
import { asyncSimpleModal, openNewWindow, setDash, setDetailPageUrl, setNumberWithComma } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';
import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import Anchor from '../../../../components/link/Anchor';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { POINT_LOG_TYPE_TEXT } from '../../../../constants/service/app/pointConstants';
import { ACCOUNT_USER_DETAIL_URL_PATH } from '../../../../constants/service/common/urlConstants';
import { ACCOUNT_USER_DETAIL_TAB_KEY } from '../../../../constants/service/app/accountUserConstants';

/**
 *  포인트 내역 리스트 컬럼
 */
export const columns = (data) => {
  const { sortOption } = data;

  return [
    {
      title: <TableColumnTitle title={'유저 ID'} />,
      dataIndex: 'userId',
      sorter: true,
      sortOrder: sortOption['userId'],
      render: (value) => (
        <Anchor
          color="primary"
          isUnderLine
          text={value}
          onClick={() =>
            openNewWindow(
              setDetailPageUrl(ACCOUNT_USER_DETAIL_URL_PATH, value) +
                `?tabKey=${ACCOUNT_USER_DETAIL_TAB_KEY.POINT_INFO}`,
            )
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'내역 종류'} />,
      dataIndex: 'type',
      render: (value) => POINT_LOG_TYPE_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'적립/사용처'} />,
      dataIndex: 'causeName',
    },
    {
      title: <TableColumnTitle title={'발급한 관리자'} />,
      dataIndex: 'adminName',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'메모'} />,
      dataIndex: 'memo',
      render: (value) =>
        value ? (
          <Anchor
            color="primary"
            isUnderLine={true}
            text={'내용 보기'}
            onClick={async () => {
              await asyncSimpleModal({
                type: 'info',
                title: '메모 내용',
                message: value,
              });
            }}
          />
        ) : (
          '-'
        ),
    },
    {
      title: <TableColumnTitle title={'액수'} />,
      dataIndex: 'amount',
      sorter: true,
      sortOrder: sortOption['amount'],
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'생성시간'} />,
      dataIndex: 'createDate',
      sorter: true,
      sortOrder: sortOption['createDate'],
      render: (value) => setDateFormat(value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
  ];
};
